import { injectable } from '@patsnap/tahiti-core/shared/inversify';
import { AbstractModel } from '@patsnap/tahiti-core';
import type { EmbodimentHistoryModel } from '../embodiment-history-model';
import type { EmbodimentHistoryState } from '../../types';

@injectable()
export class EmbodimentHistoryModelImpl extends AbstractModel<EmbodimentHistoryState> implements EmbodimentHistoryModel {
    protected _modelData: EmbodimentHistoryState = {
        history: [],
        historyIndex: 0,
    };
}
